<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ObPopup',
  props: {
    popUpHeadline: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['showObModal', 'fromUrl']),

    toggleModal() {
      if (this.showObModal) {
        this.$nextTick(() => {
          $('#obPopupModal').modal('show');
        });
        return true;
      }else {
        this.$nextTick(() => {
          $('#obPopupModal').modal('hide');
        });
        return false;
      }
    },
  },
  methods: {
    ...mapActions(),
    localClicked(value) {
      if (value) {
        this.$store.commit('SET_FROM_URL', 'OB-Landing-' + value);
      }
      this.$nextTick(() => {
        $('#obPopupModal').modal('hide');
      });
      this.$store.commit('SET_SHOW_OB_MODAL', false);
    },
  },
};
</script>

<template>
  <div v-if="toggleModal" class="form-popup-selection">
    <button id="selectionPopupTrigger" data-toggle="modal" data-target="#obPopupModal"></button>
    <div class="modal fade" id="obPopupModal" tabindex="-1" role="dialog" aria-labelledby="obPopupModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="obPopupModal">{{ popUpHeadline }}</h5>
          </div>
          <div class="modal-body">
            <div>
              <button @click="localClicked('Berlin-Neukölln')" class="sel-btn btn btn-primary">Berlin-Neukölln</button>
              <button @click="localClicked('Berlin-Lichtenberg')" class="sel-btn btn btn-primary">Berlin-Lichtenberg</button>
              <button @click="localClicked('Berlin-Pankow')" class="sel-btn btn btn-primary">Berlin-Pankow</button>
              <button @click="localClicked('Berlin-Reinickendorf')" class="sel-btn btn btn-primary">Berlin-Reinickendorf</button>
              <button @click="localClicked('Berlin-Siemensstadt')" class="sel-btn btn btn-primary">Berlin-Siemensstadt</button>
              <button @click="localClicked('Berlin-Spandau')" class="sel-btn btn btn-primary">Berlin-Spandau</button>
              <button @click="localClicked('Berlin-Steglitz')" class="sel-btn btn btn-primary">Berlin-Steglitz</button>
              <button @click="localClicked('Berlin-Treptow')" class="sel-btn btn btn-primary">Berlin-Treptow</button>
              <button @click="localClicked('Berlin-Wedding')" class="sel-btn btn btn-primary">Berlin-Wedding</button>
              <button @click="localClicked('Berlin-Weißensee')" class="sel-btn btn btn-primary">Berlin-Weißensee</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'ObPopup';
</style>
